import { ChangeDetectionStrategy, Component, computed, inject, input, model } from '@angular/core';
import { CdkListbox, CdkOption } from '@angular/cdk/listbox';

import { IconComponent } from '../../../../shared/icon/icon.component';
import type { Location } from '../../../locations/location.model';
import { FilterDropdown } from '../../../../shared/directives/filter-dropdown';
import { LocationAvatarComponent } from './location-avatar.component';

const ALL_LOCATIONS = 'all';

interface LocationOption {
  readonly id: string;
  readonly label: string;
  readonly city?: string;
  // `null` is the "All locations" entry.
  readonly location: Location | null;
}

@Component({
  selector: 'app-location-select',
  imports: [CdkListbox, CdkOption, IconComponent, LocationAvatarComponent],
  templateUrl: './location-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'relative' },
  hostDirectives: [{ directive: FilterDropdown, outputs: ['opened'] }],
})
export class LocationSelectComponent {
  protected readonly dropdown = inject(FilterDropdown);

  readonly locations = input<readonly Location[]>([]);
  // A location id, or 'all'.
  readonly value = model<string>(ALL_LOCATIONS);

  protected readonly options = computed<readonly LocationOption[]>(() => [
    { id: ALL_LOCATIONS, label: 'All locations', location: null },
    ...this.locations().map(location => ({ id: location.id, label: location.name, city: location.city, location })),
  ]);

  protected readonly selected = computed(
    () => this.options().find(option => option.id === this.value()) ?? this.options()[0]
  );
}
